// =============================================================================
// MeuDriver — StudentAware
// =============================================================================
// Aluno logado que abre a busca ou o perfil público de um instrutor
// (/instrutores, /instrutores/:slug) vê a mesma página dentro do próprio painel
// (/aluno/instrutores…), com o menu lateral. Visitante e outros perfis seguem
// na versão pública.

import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function StudentAware({ children }: { children: ReactNode }) {
  const { profile } = useAuth()
  const location = useLocation()
  if (profile?.role === 'student') {
    return <Navigate to={`/aluno${location.pathname}${location.search}`} replace />
  }
  return <>{children}</>
}

export default StudentAware
